export default function GetDirectionColor(props: number) {
  // console.log("GetPriorityColor", props);

  let color = 'primary';

  switch (props) {
    case 0:
      color = 'third.light';
      break;
    case 1:
      color = 'success.light';
      break;
    case 2:
      color = 'third.light';
      break;
    case 3:
      color = 'third.light';
      break;
    case 4:
      color = 'success.light';
      break;
    case 5:
      color = 'third.light';
      break;
    default:
      color = 'primary.light';
      break;
  }
  // console.log("GetPriorityColor color - " , color);

  return color;
}
